<script>import Tag from "../Tag.svelte";
export let props;
$: props = { ...props, classNames: `${props.classNames ?? ""} bg-secondary text-white` };
</script>

<Tag {props}>
	<slot />
</Tag>
